module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/683c810cb12f00cc5720ca08c63c6fdb.png";